import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PaymentsActions from "../../../redux/reducers/payments.reducer";

/**
 * Hook para manejar datos del historial de pagos desde Redux.
 * Centraliza la obtención y transformación de datos de pagos.
 */
export const usePaymentHistoryData = () => {
  const dispatch = useDispatch();
  const paymentsState = useSelector(({ payments }) => payments);

  const {
    issuerPaymentList,
    paymentsList: list,
    listSize,
    isFetching,
    isLoading
  } = paymentsState;

  // Transformar lista de campañas para los filtros
  const campaigns = useMemo(
    () =>
      issuerPaymentList.map((item) => ({
        id: item.campaign_id,
        value: item.campaign_id,
        text: item.name
      })),
    [issuerPaymentList]
  );

  // Despachar carga de pagos (modo replace para paginación tradicional)
  const loadPayments = (params) => {
    dispatch(
      PaymentsActions.getPayments({
        url: { ...params, replace: true }
      })
    );
  };

  // Total de items y páginas para la paginación
  const totalItems = listSize || 0;

  return {
    campaigns,
    paymentsList: list,
    listSize,
    totalItems,
    isFetching,
    isLoading,
    loadPayments
  };
};
